import { render } from "./SoftwareIntegrations.vue?vue&type=template&id=2a5affea&scoped=true"
import script from "./SoftwareIntegrations.vue?vue&type=script&lang=js"
export * from "./SoftwareIntegrations.vue?vue&type=script&lang=js"

import "./SoftwareIntegrations.vue?vue&type=style&index=0&id=2a5affea&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5affea"]])

export default __exports__